{
  "version": 1,
  "asset_id": "49ba3356-122d-475b-b2f3-1c1909e0454a",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/49ba3356-122d-475b-b2f3-1c1909e0454a/loc-san-antonio-1280.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/49ba3356-122d-475b-b2f3-1c1909e0454a/loc-san-antonio-1280.webp",
  "original_filename": "loc-san-antonio-1280.webp",
  "size": 137512,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:34Z"
}
